import serialize from "form-serialize"
import merge from 'lodash.merge';
import DirtyForm from 'dirty-form'

class ContactForm {

  constructor (options = {}) {

    options = merge({
      form: null,
      onSubmit: null,
      onLoad: null,
    }, options);

    this.$form = $(options.form);

    // disable form for no permissions user
    if(window.currentUser.level && window.currentUser.level == 0) {
      this.$form.find('button').attr('disabled', true);
    }

    // loading existing values
    this.data = null;

    if(options.data) {
      this.data = options.data;
    }

    this.onSubmit = options.onSubmit;
    this.onLoad = options.onLoad;

    this.$form_message = this.$form.find('.setting-save__message');
    this.$form_button = this.$form.find('.setting-save__button button');

    this.$form.on('change', () => {
      this.enableForm();
      this.$form_message.html('');
    });

    if(this.data) {
      this.loadData();
    } else {

      if(this.onLoad !== null) {
        this.onLoad();
      }

    }

    new DirtyForm(this.$form[0], {
      message: 'You haven\'t saved changes to this contact, are you sure you want to leave?'
    });

    this.$form.on('submit', e => {

      e.preventDefault();

      const data = serialize(this.$form[0], {hash: true});

      this.onSubmit(data);

    });


  }

  loadData() {

    if(this.data) {

      console.log(this.data);

      this.$form.find('[name="contact_name"]').val(this.data.contact_name);

      if(this.data.email) {
        this.$form.find('[name="email"]').val(this.data.email);
      }

      if(this.data.email) {

        let phone = this.data.tel_text;
        let phoneMatch = null;

        if(this.data.tel_text) {
          if (phoneMatch = this.data.tel_text.match(/(\d{3})(\d{3})(\d{4})/)) {
            phone = phoneMatch[1] + '-' + phoneMatch[2] + '-' + phoneMatch[3];
          }
        }

        this.$form.find('[name="tel_text"]').val(phone);
      }

      if(this.data.tel_text_carrier) {
        this.$form.find('[name="tel_text_carrier"]').val(this.data.tel_text_carrier);
      }

      if(this.onLoad !== null) {
        this.onLoad();
      }

    }

  }

  showFormMessage(message, isError = false) {

    this.$form_message.html(message);

    if(isError) {
      this.$form_message.toggleClass('is-error', true);
    } else {
      this.$form_message.toggleClass('is-error', false);
    }

  }

  enableForm() {
    this.$form_button.attr('disabled', false);
  }

  disableForm() {
    this.$form_button.attr('disabled', true);
  }

}

export default ContactForm;
